(function () {
  'use strict';

  // ── EFFET HOVER ──
  function initHover() {
    var cards = document.querySelectorAll('.lrn-sect-card');
    if (!cards.length) return;
    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        cards.forEach(function (c) { if (c !== card) c.style.opacity = '.55'; });
      });
      card.addEventListener('mouseleave', function () {
        cards.forEach(function (c) { c.style.opacity = '1'; });
      });
    });
  }

  // ── CAROUSEL MOBILE ──
  function initCarousel(section) {
    var wrap = section.querySelector('.lrn-sect-carousel-wrap');
    var track = section.querySelector('.lrn-sect-carousel');
    var dotsWrap = section.querySelector('.lrn-sect-dots');
    var btnPrev = section.querySelector('.lrn-sect-nav--prev');
    var btnNext = section.querySelector('.lrn-sect-nav--next');

    if (!track || !wrap) return;

    var cards = Array.from(track.querySelectorAll('.lrn-sect-card'));
    if (!cards.length) return;

    var current = 0;
    var startX = 0;
    var dragDelta = 0;
    var isDragging = false;

    // Créer les dots
    dotsWrap.innerHTML = '';
    cards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'lrn-sect-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Carte ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(dot);
    });

    function getOffset(index) {
      var card = cards[index];
      if (!card) return 0;
      return card.offsetLeft - (wrap.clientWidth - card.clientWidth) / 2;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, cards.length - 1));
      track.style.transform = 'translateX(-' + getOffset(current) + 'px)';
      dotsWrap.querySelectorAll('.lrn-sect-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

    // Swipe souris
    track.addEventListener('mousedown', function (e) {
      isDragging = true; startX = e.clientX; dragDelta = 0;
      track.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      dragDelta = e.clientX - startX;
    });
    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      if (dragDelta < -50) goTo(current + 1);
      else if (dragDelta > 50) goTo(current - 1);
    });

    // Swipe tactile
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; dragDelta = 0;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      dragDelta = e.changedTouches[0].clientX - startX;
      if (dragDelta < -50) goTo(current + 1);
      else if (dragDelta > 50) goTo(current - 1);
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(current); });
  }

  function init() {
    initHover();
    document.querySelectorAll('.lrn-sect-section').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.lrn-sect-section')) init();
  });

})();